import { render, staticRenderFns } from "./editHtmlGameForm.vue?vue&type=template&id=12275756&"
import script from "./editHtmlGameForm.vue?vue&type=script&lang=js&"
export * from "./editHtmlGameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports